// extracted by mini-css-extract-plugin
module.exports = {"video":"style_video__UMuBy","videoCloseButton":"style_videoCloseButton__1pr8W","videoTitle":"style_videoTitle__ZA_tv"};